import "es6-promise/auto";
import axios from "axios";

export function owmGetData(lat, lon) {
  return axios({
    method: "post",
    url:
      "https://api.openweathermap.org/data/2.5/onecall?lat=" +
      lat +
      "&lon=" +
      lon +
      "&exclude=current,minutely,hourly&units=metric&appid=e2ef6da4a9c6a50981e04dc1212e0282"
  })
    .then(res => res.data)
    .catch(error => error);
}

const host = "https://deburen-p-wapp-001-exporter.azurewebsites.net/weatherdata";

export function getATV() {
  return axios({
    method: "get",
    url: host + "/data-atv.php"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getATVjson() {
  return axios({
    method: "get",
    url: host + "/data/atv.json"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTVL() {
  return axios({
    method: "get",
    url: host + "/data-tvl.php"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTVLjson() {
  return axios({
    method: "get",
    url: host + "/data/tvl.json"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getROB() {
  return axios({
    method: "get",
    url: host + "/data-brussel.php"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getROBjson() {
  return axios({
    method: "get",
    url: host + "/data/rob.json"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTVO() {
  return axios({
    method: "get",
    url: host + "/data-tvo.php"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTVOjson() {
  return axios({
    method: "get",
    url: host + "/data/tvo.json"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getKust() {
  return axios({
    method: "get",
    url: host + "/data-kust.php"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getArdennen() {
  return axios({
    method: "get",
    url: host + "/data-signal.php"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function saveData(channel, data) {
  var params = new URLSearchParams();
  params.append("channel", channel);
  params.append("data", JSON.stringify(data));

  return axios({
    method: "post",
    url: host + "/save.php",
    data: params
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getWindDirection(bearing) {
  if (bearing > 337.5 || bearing < 22.5) {
    return "N";
  } else if (bearing >= 22.5 && bearing < 67.5) {
    return "NO";
  } else if (bearing >= 67.5 && bearing < 112.5) {
    return "O";
  } else if (bearing >= 112.5 && bearing < 157.5) {
    return "ZO";
  } else if (bearing >= 157.5 && bearing < 202.5) {
    return "Z";
  } else if (bearing >= 202.5 && bearing < 247.5) {
    return "ZW";
  } else if (bearing >= 247.5 && bearing < 292.5) {
    return "W";
  } else {
    return "NW";
  }
}

export function dayOfWeek(i) {
  if (i === 0) {
    return "Zondag";
  } else if (i === 1) {
    return "Maandag";
  } else if (i === 2) {
    return "Dinsdag";
  } else if (i === 3) {
    return "Woensdag";
  } else if (i === 4) {
    return "Donderdag";
  } else if (i === 5) {
    return "Vrijdag";
  } else if (i === 6) {
    return "Zaterdag";
  } else if (i === 7) {
    return "Zondag";
  } else if (i === 8) {
    return "Maandag";
  } else if (i === 9) {
    return "Dinsdag";
  } else if (i === 10) {
    return "Woesdag";
  } else if (i === 11) {
    return "Donderdag";
  } else if (i === 12) {
    return "Vrijdag";
  } else if (i === 13) {
    return "Zaterdag";
  } else {
    return "Zondag";
  }
}

export function dayOfWeekShort(i) {
  if (i === 0) {
    return "Zon";
  } else if (i === 1) {
    return "Maa";
  } else if (i === 2) {
    return "Din";
  } else if (i === 3) {
    return "Woe";
  } else if (i === 4) {
    return "Don";
  } else if (i === 5) {
    return "Vrij";
  } else if (i === 6) {
    return "Zat";
  } else if (i === 7) {
    return "Zon";
  } else if (i === 8) {
    return "Maa";
  } else if (i === 9) {
    return "Din";
  } else if (i === 10) {
    return "Woe";
  } else if (i === 11) {
    return "Don";
  } else if (i === 12) {
    return "Vrij";
  } else if (i === 13) {
    return "Zat";
  } else {
    return "Zond";
  }
}

export function getWindSpeed(speed) {
  if (speed < 1) {
    return "windstil";
  } else if (speed >= 1 && speed < 12) {
    return "zwak";
  } else if (speed >= 12 && speed < 29) {
    return "matig";
  } else if (speed >= 29 && speed < 50) {
    return "vrij krachtig";
  } else {
    return "krachtig";
  }
}
